import * as d3 from "d3";
import {
    colonAnnotation,
    contextMenu,
    createTooltip,
    generateDownloadData,
    numberFormat,
    responsivefy
} from "@/common/functions";

export default function (chart, divId, vizName, resData,filterParam) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // axios.post(url, filterParam).then(res => {
        let data = resData;

        // append the svg object to the body of the page
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chart.width - chart.margin.left + chart.margin.right)
            .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        // Build scales x-axis and y-axis
        var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).padding(0.01)
        var y1Scale = d3.scaleBand().rangeRound([chart.height, 0]).padding(0.02)
        //calling scales
        var x1AxisLabel = d3.axisBottom().scale(x1Scale)
        var y1AxisLabel = d3.axisLeft().scale(y1Scale)
        // Build color scales
        var metric1ColorScale = d3.scaleLinear()
            .range(["#f1eef6", "#08306b"])
            .domain([d3.min(data, (d) => {
                return d.metric1
            }),
                d3.max(data, (d) => {
                    return d.metric1
                })
            ]);

        // Labels of row and columns
        x1Scale.domain(data.map((d) => {
            return d.dim1_name
        }))
        y1Scale.domain(data.map((d) => {
            return d.dim2_name
        }).sort(d3.descending))


        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(x1AxisLabel)
            .selectAll('.tick text')
            .style('text-anchor', 'end') // Adjust text-anchor to 'end'
            .attr('dx', '-.8em') // Adjust horizontal spacing
            .attr('dy', '-.15em') // Adjust vertical spacing
            .attr('transform', 'rotate(-45)') // Rotate the labels for better visibility
            .attr('font-size', '13px'); // You can set font-size here if needed


        svg.append('g')
            .attr('class', 'y axis')
            .call(y1AxisLabel)
            .selectAll('text')
            .style('text-anchor', 'end')
            .attr('dy', '-.0em') // Adjust vertical spacing
            .attr('dx', '-.0em') // Adjust horizontal spacing
            .attr('font-size', '13px');


        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + (chart.margin.bottom - 20))
            .text(chart.x1AxisDisplayName)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .text(chart.y1AxisDisplayName)

        // create a tooltip
        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
        var y1tip = tooltip_class()

        y1tip.attr('class', 'd3-tip'+divId.id)
            .html((d) =>{
                return d.dim1_name+ colonAnnotation +d.dim2_name+ colonAnnotation + numberFormat(d.metric1)
            })

        svg.call(y1tip);*/

        const tooltip = createTooltip(divId);
        // add the squares
        svg.selectAll()
            .data(data, (d) => {
                return d.dim1_name + ':' + d.dim2_name
            })
            .enter()
            .append('rect')
            .attr('x', (d) => {
                return x1Scale(d.dim1_name)
            })
            .attr('y', (d) => {
                return y1Scale(d.dim2_name)
            })
            .attr('width', x1Scale.bandwidth())
            .attr('height', y1Scale.bandwidth())
            .style('fill', (d) => {
                return metric1ColorScale(d.metric1)
            })
            .on("mouseover", function(d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x1MetricTooltip + colonAnnotation + d.dim1_name
                        + '<br>' + chart.y1MetricTooltip + colonAnnotation + d.dim2_name
                        + '<br>' + "Revenue"+ colonAnnotation + numberFormat(d.metric1)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            })
            .on('contextmenu', function(d) {
                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name], // e.g., "metric1"
                    [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]:[d.dim2_name]
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            })
        //.on("mouseover", y1tip.show)
        //.on("mouseout", y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
    // })
}